import { LinkPrimary } from 'mage-deps/@klarna/bubble-ui'
import { Framework } from 'mage-deps/@klarna/mp-ui'
import { translator } from 'mage-i18n'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

const Error = ({ t, errorId }) => {
  const contactContent = t(
    'core.errorBoundary.contact',
    {
      errorId: <strong>{errorId}</strong>,
      br: <br />,
      // eslint-disable-next-line react/display-name
      supportLink: children => (
        <LinkPrimary
          href='https://www.klarna.com/merchant-support' target='_blank'
          inParagraph
        >
          {children}
        </LinkPrimary>)
    },
    'Please try refreshing the page')

  return (
    <Framework
      hasError
      errorProps={{
        title: t('core.errorBoundary.title', {}, 'Unexpected Error'),
        contactContent: [contactContent],
        errorDescription: t('core.errorBoundary.errorDescription', { errorId }),
        reloadButton: {
          text: t('core.errorBoundary.reloadButton', {}, 'Reload')
        }
      }}
    />
  )
}

Error.propTypes = {
  t: PropTypes.func.isRequired,
  errorId: PropTypes.string
}

export default connect(
  state => ({
    t: translator(state)
  })
)(Error)
